export default __webpack_public_path__ + "static/media/socialLinkedin.4767fec2.svg";